import React from 'react';
import { FormikSelect } from 'components/UiKit/FormikFields';
import statesItems from 'components/AddressFields/StateSelect/data';
import getDropdownParentWithoutDetaching from 'utilities/getDropdownParentWithoutDetaching';
import PersonFieldLabel from '../PersonFieldLabel';

function StateField() {
  return (
    <div className="my-4 w-full">
      <div className="block ml-6">
        <div className="w-full">
          <PersonFieldLabel htmlFor="state-select">State</PersonFieldLabel>
        </div>
        <div className="w-full">
          <FormikSelect
            id="state-select"
            name="state"
            items={statesItems}
            placeholder="Select"
            getPopupContainer={getDropdownParentWithoutDetaching}
          />
        </div>
      </div>
    </div>
  );
}

export default StateField;
